import { useState } from 'react';

function useHover() {
    const [ hovered, setHovered ] = useState(false);

    const handleMouseEnter = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    return {
        hovered,
        bind: {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
        },
    };
}

export default useHover;
